import { z } from 'zod';
import { uuid } from './common.js';
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD');
// ── Roster ("Trainer" admin page) ───────────────────────────────────────────
export const addTrainerRequest = z.object({
    memberId: uuid,
});
/** Hex-Farbcode wie im `<input type="color">` (`#rrggbb`), oder `null` für
 * die neutrale Standardfarbe. */
export const trainerColor = z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/, 'Hex-Farbcode wie #2563eb')
    .nullable();
/** PUT /trainers/:memberId — Ersetzt-alle-Semantik für `rates` wie bei
 * `setTeamManagerTeamsRequest`: die übergebene Liste ist der neue
 * vollständige Satz an Sätzen für diesen Trainer, keine inkrementelle
 * Änderung. Eine Trainingsgruppe ohne Eintrag hier hat danach keinen Satz
 * mehr (falls vorher einer bestand, wird er entfernt). `color` wird immer
 * komplett ersetzt (kein Merge nötig, ein einzelner Wert). */
export const updateTrainerRequest = z.object({
    rates: z.array(z.object({ trainingGroupId: uuid, hourlyRate: z.number().positive().max(9999) })),
    color: trainerColor,
});
// ── Check-in ("Trainer" work page) ──────────────────────────────────────────
export const checkInRequest = z.object({
    /** Optional override of the auto-computed hours (event duration) — a
     * trainer who only covered part of the session can correct it here. */
    hours: z.number().positive().max(24).optional(),
});
/** PUT /trainers/checkins/:checkInId (`trainers.manage`, § Nutzeranfrage) —
 * Korrektur einer beliebigen bestehenden Eintragung durch den Vereinsadmin,
 * statt sie löschen und neu anlegen zu müssen. Ändert bewusst nur `hours`,
 * nicht den zum Eintragungszeitpunkt gespeicherten `hourlyRate`-Schnappschuss. */
export const updateCheckInRequest = z.object({
    hours: z.number().positive().max(24),
});
/** POST /trainers/events/:eventId/checkins (`trainers.manage`, § Nutzeranfrage
 * „ich möchte auch selber Trainer für Trainingszeiten eintragen können") —
 * das Admin-Pendant zu `checkInRequest`: trägt ein beliebiges Roster-
 * Mitglied ein statt nur den aufrufenden Trainer selbst. */
export const adminCheckInRequest = z.object({
    memberId: uuid,
    hours: z.number().positive().max(24).optional(),
});
/** Month-Vor/Zurück-Navigation auf der Trainer-Arbeitsseite (§ Nutzeranfrage,
 * ersetzt das frühere `sinceDays`-Fenster) — beide optional, fehlen sie
 * defaultet der Server auf den aktuellen Monat (siehe
 * `TrainersController.listCheckableEvents`). */
export const checkableEventsQuery = z.object({
    year: z.coerce.number().int().min(2000).max(3000).optional(),
    month: z.coerce.number().int().min(1).max(12).optional(),
});
// ── Auswertung/Export (admin page) ──────────────────────────────────────────
export const trainerExportQuery = z.object({
    from: isoDate,
    to: isoDate,
});
// ── Monatsübersicht (admin page, § Nutzeranfrage) ───────────────────────────
export const trainerSessionsQuery = z.object({
    year: z.coerce.number().int().min(2000).max(3000),
    month: z.coerce.number().int().min(1).max(12),
});
// ── Monatssperre (admin page, § Nutzeranfrage) ──────────────────────────────
export const trainerMonthParams = z.object({
    year: z.coerce.number().int().min(2000).max(3000),
    month: z.coerce.number().int().min(1).max(12),
});
/** PUT /trainers/months/:year/:month — jedes Feld ersetzt den bisherigen
 * Wert vollständig, ein weggelassenes Feld bleibt unverändert (kein
 * Merge-Zwang: der Admin kann die Deadline setzen, ohne den
 * Offen/Geschlossen-Status anzufassen, und umgekehrt). */
export const setTrainerMonthStatusRequest = z.object({
    deadline: isoDate.nullable().optional(),
    closed: z.boolean().optional(),
});
//# sourceMappingURL=trainers.js.map